export default {"src":"/_next/static/media/festival.306ed15f.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};